
export const data = [
    {
        id:1,
        hotelID: '#HT001',
        HotelName: 'Radisson Blu',
        contactNumber: '+65 987 654 321',
        emailAddress: 'raj198672@gmail.com',
        address1: '34, South West Road',
        address2: 'Cross Estate',
        city: 'Singapore North',
        country: 'Singapore',
        userAccount: 25,
        status: 'Active',
        statusColor: 'success'
    },
    {
        id:2,
        hotelID: '#HT002',
        HotelName: 'Radisson Blu',
        contactNumber: '+65 987 654 321',
        emailAddress: 'raj198672@gmail.com',
        address1: '34, South West Road',
        address2: 'Cross Estate',
        city: 'Singapore North',
        country: 'Singapore',
        userAccount: 25,
        status: 'Active',
        statusColor: 'success'
    },
    {
        id:3,
        hotelID: '#HT003',
        HotelName: 'Radisson Blu',
        contactNumber: '+65 987 654 321',
        emailAddress: 'raj198672@gmail.com',
        address1: '34, South West Road',
        address2: 'Cross Estate',
        city: 'Singapore North',
        country: 'Singapore',
        userAccount: 25,
        status: 'Active',
        statusColor: 'success'
    },
    {
        id:4,
        hotelID: '#HT004',
        HotelName: 'Radisson Blu',
        contactNumber: '+65 987 654 321',
        emailAddress: 'raj198672@gmail.com',
        address1: '34, South West Road',
        address2: 'Cross Estate',
        city: 'Singapore North',
        country: 'Singapore',
        userAccount: 25,
        status: 'Active',
        statusColor: 'success'
    },
    {
        id:5,
        hotelID: '#HT005',
        HotelName: 'Radisson Blu',
        contactNumber: '+65 987 654 321',
        emailAddress: 'raj198672@gmail.com',
        address1: '34, South West Road',
        address2: 'Cross Estate',
        city: 'Singapore North',
        country: 'Singapore',
        userAccount: 25,
        status: 'Active',
        statusColor: 'success'
    },
    {
        id:6,
        hotelID: '#HT006',
        HotelName: 'Radisson Blu',
        contactNumber: '+65 987 654 321',
        emailAddress: 'raj198672@gmail.com',
        address1: '34, South West Road',
        address2: 'Cross Estate',
        city: 'Singapore North',
        country: 'Singapore',
        userAccount: 25,
        status: 'Active',
        statusColor: 'success'
    }

]

export const cityList = [
    {
        options: [
            { label: "Select City", value: "Select City" },
            { label: "Aljunied", value: "Aljunied" },
            { label: "East Coast", value: "East Coast" },
            { label: "Hong Kah", value: "Hong Kah" },
            { label: "Jalan Besar", value: "Jalan Besar" },
        ]
    }
]
export const countryList = [
    {
        options: [
            { label: "Select Country", value: "Select Country" },
            { label: "Singapore", value: "Singapore"},
            { label: "East Coast", value: "East Coast" },
            { label: "Hong Kah", value: "Hong Kah" },
            { label: "Jalan Besar", value: "Jalan Besar" },
        ]
    }
]